import { trackAbTestEvent } from 'dibs-tracking';

import {
    isAbTestVariant,
    getAbTestTrackingData,
} from 'dibs-buyer-layout/exports/clientABTestHelpers';

const SAVE_ICON_UPDATES_PDP = 'SAVE_ICON_UPDATES_PDP';

export const isSaveIconUpdateAbTestVariant = (): boolean =>
    isAbTestVariant(document.cookie, SAVE_ICON_UPDATES_PDP);

export const trackSaveIconUpdateAbTest = (): void => {
    const trackingData = getAbTestTrackingData(document.cookie, SAVE_ICON_UPDATES_PDP);
    trackAbTestEvent(trackingData, 'save_icon_updates_pdp');
};
